import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import CustomerValidationFetch from '../customer/CustomerValidationFetch';


import AbEnvironment from '../auth/AbEnvironment';
import CustomerFetch from '../customer/CustomerFetch';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, InputLabel, MenuItem, Paper, 
         TextField, Tooltip, Typography
} from '@mui/material';
import Search from '@mui/icons-material/Search';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();

function renderInputComponent(inputProps) {
   const { classes, inputRef = () => {}, ref, ...other } = inputProps;
  
  return (
    <TextField
      fullWidth
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input,
        },
      }}
      {...other}
    />
  );
}
  
function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.accountName, query);
  const parts = parse(suggestion.accountName, matches);
  
  return (
    <MenuItem selected={isHighlighted} component="div">
      <Grid container spacing={2} direction="row" justifyContent="flex-start">
        <Grid item xs={5}>
          <Typography variant="subtitle1" >
          {parts.map((part, index) => {
            if (part.highlight) {
              return (<strong key={index}>{part.text}</strong>);
            } else {
              return (part.text);
            }
          })}
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography variant="subtitle1" data-recording-sensitive>
            {suggestion.contactFirstName} {suggestion.contactLastName}
          </Typography>
        </Grid>
      </Grid>
    </MenuItem>
  );
}

const getSuggestionValue = suggestion => suggestion.accountName;

//these two needed to make warnings go away in autoselect.  Should not be the case according to doc.
function getSectionSuggestions(section) {
  return null;
}

function renderSectionTitle(section) {
  return null;
}

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    container: {
      position: 'relative',
    },
    suggestionsContainerOpen: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
    },
    suggestion: {
      display: 'block',
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none',
    },
    divider: {
      height: theme.spacing(2),
    },
    paper: {
      marginTop: 16,
      //padding: theme.spacing(3),
      textAlign: 'left',
      maxWidth: 980
    },
    configGrid: {
      marginTop: 4,
    },
    button: {
      marginTop: 15,
      marginBottom: 15,
      marginRight: 8
    },
    customText: {
      margin: 8
    },
    searchList: {
      paddingTop: 0,
      width: '100%'
    }
});

class StepCustomer extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      suggestions: [],
      searchP: '',
      dupCustomer: false,
      dupEmail: false,
      customerSearching: false,
      lowCustomerCount: false,
      showEditingFields: false
    }

    this.provisioner = {
      userId:           abEnvironment.getUserAttribute('u_id'),
      accountId:        abEnvironment.getUserAttribute('a_id'),
      accountName:      abEnvironment.getUserAttribute('a_accountName'),
      description:      abEnvironment.getUserAttribute('a_description'),
      contactLastName:  abEnvironment.getUserAttribute('a_lastName'),
      contactFirstName: abEnvironment.getUserAttribute('a_firstName'),
      contactEmail:     abEnvironment.getUserAttribute('a_email'),
      contactPhone:     abEnvironment.getUserAttribute('a_phone'),
      address1:         abEnvironment.getUserAttribute('a_address1'),
      address2:         abEnvironment.getUserAttribute('a_address2'),
      city:             abEnvironment.getUserAttribute('a_city'),
      state:            abEnvironment.getUserAttribute('a_state'),
      country:          abEnvironment.getUserAttribute('a_country'),
      postalCode:       abEnvironment.getUserAttribute('a_postalCode')
    }
    this.customerSelected = false;
  }

  componentDidMount() {
    if (this.props.auth.isAuthenticatedReseller()) {
      this.fetchCustomerCount();
    } else {
      this.setState({showEditingFields: true});
    }
  }

  handleChange = name => event => {
    if (name === 'searchP') {
      this.setState({searchP: event.target.value});
    } 
  };
  handleInputChange = (name, value) => {

    if (this.props.customer.accountId) {
      //if they try and change a customer detail, blank everything out first
      this.props.setCustomerStateChanged('accountId', '' );
      this.props.setCustomerStateChanged('companyName', '' );
      this.props.setCustomerStateChanged('contactLastName', '' );
      this.props.setCustomerStateChanged('contactFirstName', '' );
      this.props.setCustomerStateChanged('contactEmail', '' );
      this.setState({searchP: ''});
    }
    this.props.setCustomerStateChanged(name, value );
 
  };
  getCustomerSearchError = () => {
    
    if( (this.state.searchP && this.state.searchP.length > 0)
      && (this.state.suggestions === undefined || (this.state.suggestions && this.state.suggestions.length === 0)) 
      && (this.props.customer.companyName !== this.state.searchP)
      && (!this.customerSearching)
    ) {
      return <Typography style={{paddingLeft: 38, marginTop : -15}}>No matching customers</Typography>
    } else {
      return '';
    }
  }

  setStateFromSelection(theCust) {
    this.props.setCustomerStateChanged('accountId', theCust.accountId );
    this.props.setCustomerStateChanged('companyName', theCust.accountName );
    this.props.setCustomerStateChanged('contactLastName', theCust.contactLastName );
    this.props.setCustomerStateChanged('contactFirstName', theCust.contactFirstName );
    this.props.setCustomerStateChanged('contactEmail', theCust.contactEmail );
 }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({customerSearching: true});
    this.fetchCustomers(value);
  }
    
  onSuggestionsClearRequested = () => {
    this.setState({suggestions: []});
    //if customer selected is false, that means the user did not actually select a customer from suggestions list.  Need to reset search box
    if (!this.customerSelected && this.props.customer.accountId) {
      //already a customer selected and it is not reseller
      this.setState({searchP: this.props.customer.accountName});
    /*} else if (!this.customerSelected && this.props.bcUser.usingAccountId === this.provisioner.accountId) {
      //already a selected and it is reseller
      this.setState({searchP: ''});*/
    } else {
      this.customerSelected = false;
    }
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) =>{
    // alert(suggestionValue);
    let customerLabel = suggestion.accountName;
    this.customerSelected = true;
    this.setStateFromSelection(suggestion);
    this.setState({searchP: customerLabel, showEditingFields: false});
   } 

   addNewClicked = () =>{
    // alert(suggestionValue);
    this.props.setCustomerStateChanged('accountId', '' );
    this.props.setCustomerStateChanged('companyName', '' );
    this.props.setCustomerStateChanged('contactLastName', '' );
    this.props.setCustomerStateChanged('contactFirstName', '' );
    this.props.setCustomerStateChanged('contactEmail', '' );
    this.setState({searchP: '', showEditingFields: true});
   } 
  /*
   * Get a customer count (with a search of nothing)
   * 11 is requested because 10 is the max that can fit.
   */
  fetchCustomerCount = () => {
    CustomerFetch.fetch("", 1, 11).toPromise()
    .then(cf => {
      const thenodes = cf.accountsearchbycustomername2.nodes;

      if (thenodes.length <= 10) {
        this.setState({lowCustomerCount: true});
        if (thenodes.length === 1) {
          let customerLabel = cf.accountsearchbycustomername2.nodes[0].accountName;
          this.customerSelected = true;
          this.setStateFromSelection(cf.accountsearchbycustomername2.nodes[0]);
          this.setState({searchP: customerLabel});
        }
     }
 
    })
    .catch(err => {
      //nothing to do....user will just need to search.
    })
  }

   /*
   * Lookup customers for selection.
   */
  fetchCustomers = (searchParm) => {
    CustomerFetch.fetch(searchParm, 1, 10).toPromise()
    .then(cf => {
      const thenodes = cf.accountsearchbycustomername2.nodes;

      let theCustomers = [];
      thenodes.forEach(n => {
        theCustomers.push(n);
      });

      this.setState({suggestions: theCustomers, customerSearching: false});
    })
    .catch(err => {
      this.setState({suggestions: [], customerSearching: false});
    })
  }

  shouldAutoRender = (value) => {
    if (this.state.lowCustomerCount || value !== "") {
      return true;
    } else {
      return false;
    }
  }

  validateCustomer = (ev) => {

    //for resellers who are logged in, we can validate duplicate customers

    if (this.props.auth.isAuthenticatedReseller()) {
      let accountId = abEnvironment.getUserAttribute('a_id');

      //this gets a list of all the apps associated with the program
      CustomerValidationFetch.fetch(accountId, this.props.customer.companyName).toPromise()
      .then(cvf => {
        if (cvf.allAccountTs.totalCount === 1) {
          this.setState({dupCustomer: true});
        } else {
          this.setState({dupCustomer: false});
        }
        
      })
      .catch(err => {
        //nothing to do....
      })
    }
  }

  validateEmailDuplicate = (ev) => {

    //for resellers who are logged in, we can validate email contents

    if (this.props.auth.isAuthenticatedReseller()) {
      const { callPartnerApi, logError } = this.props.auth;

    
      // Check on uniqueness prior to account or user persistence.
      callPartnerApi('appbind/usercount/' + this.props.customer.contactEmail,
                    'GET',
                    null)
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.userCount != null)
        {
          if (data.userCount > 0)
          {
            this.setState({dupEmail: true});

          } else {
            this.setState({dupEmail: false});
          }
        }
        else
        {
          throw(data);
        }
      }).catch(err => {
        logError('Exception in StepCustomer.js' + err)
      })
    }
  }



  isInformationComplete() {

    const { validateEmail } = this.props.auth;

    if (this.props.customer.companyName === '')
      return false;

    if (this.props.customer.contactFirstName === '')
      return false;

    if (this.props.customer.contactLastName === '')
      return false;

    if (this.props.customer.contactEmail === '')
      return false;

    if (this.state.dupCustomer) {
      return false;
    }

    if (this.state.dupEmail) {
      return false;
    }

    // Is email an email address?
    let emailOk = validateEmail(this.props.customer.contactEmail);
    if (! emailOk)
      return false;

    return true;
  }

  
  isBackDisabled() {
    if (this.props.activeStep === 0)
      return true;

    if (this.props.auth.isAuthenticatedReseller()) {
      return true;
    }

    return false;
  }

  isNextDisabled() {
    
    if (this.props.activeStep === this.props.assignedStep) {
      if (!this.isInformationComplete()) {
        return true;
      } 
    }
    return false;
  }


  handleNext() {
    if (this.props.auth.isAuthenticatedReseller() && this.state.showEditingFields) {
      //for a reseller logged on, we need to ensure the customer and email validation fire before moving on
      // Check on uniqueness prior to account or user persistence.
      const { callPartnerApi } = this.props.auth;
      let accountId = abEnvironment.getUserAttribute('a_id');

      callPartnerApi('appbind/usercount/' + this.props.customer.contactEmail,
                      'GET',
                      null)
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.userCount != null) {
            if (data.userCount > 0) {
              this.setState({dupEmail: true});
              let theMessage = 'Email address ' + this.props.customer.contactEmail + ' is already a registered user in AppBind.  Please check the email and make sure that you are not inviting an existing user.'
              // This email is already in use
              var theError = {
                errMessage: theMessage
              };
              throw(theError);
            } else {
              return data;
            }
          }
          else {
            throw(data);
          }
        })
        .then( () => {
          return CustomerValidationFetch.fetch(accountId, this.props.customer.companyName).toPromise();
        })

        .then(cvf => {

          if (cvf.allAccountTs.totalCount === 1) {
            this.setState({dupCustomer: true});
            let theMessage = 'Customer already exists with this name';
            // This email is already in use
            var theError = {
              errMessage: theMessage
            };
            throw(theError);
          } 
          this.props.handleNext();

        })
        .catch(error => {
          //something wrong validating.
          console.log(error);      
        });

    } else {
      //cannot validate since user not logged in or not trying to add new.
      this.props.handleNext();
    }
  }

  render() {
    const classes = this.props.classes;

    const { validateEmail } = this.props.auth;

    let customerLabel = 'Search for existing customer by name';


    let inpValue = this.state.searchP;
    if (inpValue == null) {
        inpValue = '';
    }

    let emailError = false;
    if (this.props.customer.contactEmail != null && this.props.customer.contactEmail !== '') {
      let emailOk = validateEmail(this.props.customer.contactEmail);
      if (! emailOk) {
        emailError = true;
      }
    }  

    let displayOnly = false;
    if (this.props.activeStep > this.props.assignedStep) {
      displayOnly = true;
    } else if (this.props.displayOnly) {
      displayOnly = true;
    }

 
      if (!displayOnly) {
        return (
  
          <Grid container spacing={2} >
            
            <Grid item xs={12}>
              <Typography variant="button">Customer</Typography>
            </Grid>
                        
            {this.props.auth.isAuthenticatedReseller() && (
              <React.Fragment>
              <Grid item xs={12}>
              <div className={classes.searchList}>
                <Autosuggest
                  renderInputComponent={renderInputComponent}
                  suggestions={this.state.suggestions}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  onSuggestionSelected={this.onSuggestionSelected}
                  getSuggestionValue={getSuggestionValue}
                  renderSuggestion={renderSuggestion}
                  shouldRenderSuggestions={this.shouldAutoRender}
                  multiSection={false}
                  renderSectionTitle={renderSectionTitle}
                  getSectionSuggestions={getSectionSuggestions}
                  inputProps={{
                    classes,
                    placeholder: customerLabel,
                    value: inpValue,
                    onChange: this.handleChange('searchP')
                  }}
                  theme={{
                    input: classes.input,
                    container: classes.container,
                    suggestionsContainerOpen: classes.suggestionsContainerOpen,
                    suggestionsList: classes.suggestionsList,
                    suggestion: classes.suggestion,
                  }}
                  renderSuggestionsContainer={options => (
                    <Paper {...options.containerProps} square>
                      {options.children}
                    </Paper>
                  )}                   
                /><Search color="disabled" style={{float: "right", marginTop: -26}}/>
                
              </div>

            </Grid>
            {!this.state.customerSearching && 
              <Grid item xs={12}>
                {this.getCustomerSearchError()}
              </Grid>
            }

            <Grid item xs={12} style={{marginLeft: -10, marginTop: -8, marginBottom: 16}}>
              <div>
                <Typography style={{display: 'inline-block'}} variant="body1">&nbsp;&nbsp;&nbsp;or&nbsp;&nbsp;&nbsp;</Typography>
                  

                <Tooltip title="Add a new customer">
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={() => {this.addNewClicked()}}>
                      
                        Add New Customer
                      
                  </Button>
                </Tooltip>
              </div>

            </Grid>
            </React.Fragment>
            )}          
                 
             
             {this.props.auth.isAuthenticatedReseller() && this.props.customer.accountId  && this.state.showEditingFields === false &&
             <Grid container >
               <Grid item xs={12} style={{marginLeft: 8}}>
                <InputLabel shrink style={{marginBottom:6}}>Customer</InputLabel>
                <Typography variant="body1" style={AppBindStyles.boldLabel}>
                  {this.props.customer.companyName}
                </Typography>
                <Typography variant="body2">
                  {this.props.customer.contactFirstName}&nbsp;{this.props.customer.contactLastName}<br/>
                  {this.props.customer.contactEmail}
                </Typography>
               </Grid>
            </Grid>
            }

            {(!this.props.auth.isAuthenticatedReseller()  || (this.props.auth.isAuthenticatedReseller() && this.state.showEditingFields === true)) &&
            <React.Fragment>
              
              <Grid item xs={12}  style={{marginTop: -16}}>
                <TextField 
                  error={this.state.dupCustomer}
                  id="company-name" label="Company *"
                  value={ this.props.customer.companyName }
                  onBlur={() => { this.validateCustomer() }}
                  onChange={ (e) => this.handleInputChange('companyName', e.target.value) }
                  inputProps={{ maxLength: 64 }}
                  helperText={this.state.dupCustomer ? 'Customer already exists with this name' : ''}
                />
              </Grid>
  
              <Grid item  xs={12} sm={6}>
                <TextField  data-recording-ignore="mask"
                  id="first-name" label="First name *"
                  value={ this.props.customer.contactFirstName }
                  onChange={ (e) => this.handleInputChange('contactFirstName', e.target.value ) }
                  inputProps={{ maxLength: 32 }}
                />
              </Grid>
      
              <Grid item  xs={12} sm={6}>
                <TextField  data-recording-ignore="mask"
                  id="last-name" label="Last name *"
                  value={ this.props.customer.contactLastName }
                  onChange={ (e) => this.handleInputChange('contactLastName', e.target.value ) }
                  inputProps={{ maxLength: 32 }}
                />
              </Grid>
      
              <Grid item xs={12}>
                <TextField  data-recording-ignore="mask"
                  id="email" label="Email *"
                  error={this.state.dupEmail || emailError}
                  value={ this.props.customer.contactEmail }
                  onBlur={() => { this.validateEmailDuplicate() }}
                  onChange={ (e) => this.handleInputChange('contactEmail', e.target.value ) }
                  helperText={this.state.dupEmail ? 'User already exists with this email' : ''}
                />
              </Grid>

              <Grid item xs={12}>
                <Paper elevation={1}>
                  <Grid container spacing={1} direction="row" justifyContent="flex-start" style={{padding: '16px'}}>
                   <Grid item xs={12}>
                      <div style={{display:"flex"}}>
                        <Typography variant="body1">
                          <strong>Tip.</strong>&nbsp;&nbsp;Your customer will only be emailed when you say so.
                        </Typography>
                      </div>
                    </Grid>      
                  </Grid>
                </Paper>
              </Grid>
          </React.Fragment>
          }
 
            {this.props.activeStep === this.props.assignedStep &&
            <Grid item xs={12}>
            <Button
              disabled={this.isBackDisabled()}
              color="primary" variant="outlined"
              onClick={() => this.props.handleBack()}
              style={AppBindStyles.bottomButton}>
              Back
            </Button>
              <Button
                disabled={this.isNextDisabled()}
                color="primary" variant="contained"
                onClick={() => this.handleNext()}
                style={AppBindStyles.bottomButton}>
                Next
              </Button>
            </Grid>
            }
          </Grid>       
        );  
        
      } else {
  
        //display only
        return (
  
          <Grid container >
            <Grid item xs={12}>
              <InputLabel shrink style={{marginBottom:6}}>Customer</InputLabel>
              <Typography variant="body1" style={AppBindStyles.boldLabel}>
                {this.props.customer.companyName}
              </Typography>
              <Typography variant="body2">
                {this.props.customer.contactFirstName}&nbsp;{this.props.customer.contactLastName}<br/>
                {this.props.customer.contactEmail}
              </Typography>
            </Grid>
          </Grid>
            
        );
    
      }

  }
}

export default withStyles(styleSheet)(StepCustomer);
